module.exports = __webpack_public_path__ + "static/img/yingrenIcon.6f26712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/yingrenIcon.png
// module id = Zd72
// module chunks = 0